import React from 'react';


const columns = [
  {
    title: 'Transaction ID',
    dataIndex: 'transactionId',
    key: 'transactionId',
    render: (text) => text || '--',
  },
  {
    title: 'Transaction Code',
    dataIndex: 'transactionCode',
    key: 'transactionCode',
    render: (text) => text || '--',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    render: (value) => (typeof value === 'number' ? value.toFixed(2) : '--'),
  },
  {
    title: 'Currency',
    dataIndex: 'currency',
    key: 'currency',
    render: (text) => text || '--',
  },
  {
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    render: (text) => text || '--',
  },
  {
    title: 'To',
    dataIndex: 'to',
    key: 'to',
    render: (text) => text || '--',
  },
  {
    title: 'Payment From',
    dataIndex: 'paymentFrom',
    key: 'paymentFrom',
    render: (text) => text || '--',
  },
  {
    title: 'Payment To',
    dataIndex: 'paymentTo',
    key: 'paymentTo',
    render: (text) => text || '--',
  },
  {
    title: 'Operation',
    dataIndex: 'operation',
    key: 'operation',
    render: (text) => text || '--',
  },
  {
    title: 'Login Terminal ID',
    dataIndex: 'loginTerminalId',
    key: 'loginTerminalId',
    render: (text) => text ?? '--',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (text) => text || '--',
  },
  {
    title: 'Transaction Date',
    dataIndex: 'transactionDate',
    key: 'transactionDate',
    render: (text) => (text ? new Date(text).toLocaleString() : '--'),
  },
  {
    title: 'Created Date',
    dataIndex: 'createdDate',
    key: 'createdDate',
    render: (text) => (text && text !== "0001-01-01T00:00:00" ? new Date(text).toLocaleString() : '--'),
  },
];

export default columns;
